<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <KTCodePreview v-bind:title="'Cập nhật IMEI'">
          <template v-slot:preview>
            <b-form ref="form" lazy-validation class="row">
              <!-- Input session -->
              <b-container class="bv-example-row">
                <b-row>
                  <b-col>
                    <b-col>
                      <b-form-group id="input-group-name">
                        <label for="input-name">Kho:</label>
                        <b-form-select
                          id="select-store"
                          required
                          v-model="selectedStore"
                          aria-describedby="input-store-live-feedback"
                          :options="listStore"
                          value-field="id"
                          text-field="name"
                          size="sm"
                        >
                          <template v-slot:first>
                            <b-form-select-option :value="null" disabled
                              >Chọn kho</b-form-select-option
                            >
                          </template>
                        </b-form-select>
                      </b-form-group>
                    </b-col>
                    <b-col>
                      <b-form-group id="input-group-name">
                        <label for="input-name">Imei:</label>
                        <b-form-input
                          v-model="imei"
                          id="input-name"
                          type="text"
                          size="sm"
                          aria-describedby="input-name-live-feedback"
                        ></b-form-input>
                      </b-form-group>
                    </b-col>
                    <b-col>
                      <b-form-group id="input-group-name">
                        <label for="input-name">Giá nhập:</label>
                        <b-form-input
                          id="input-name"
                          v-model="originalPrice"
                          type="text"
                          size="sm"
                          aria-describedby="input-name-live-feedback"
                          v-mask="mask"
                        ></b-form-input>
                      </b-form-group>
                    </b-col>
                    <b-col>
                      <b-form-group id="input-group-name">
                        <label for="input-name">Giá bán:</label>
                        <b-form-input
                          id="input-name"
                          v-model="sellingPrice"
                          type="text"
                          size="sm"
                          aria-describedby="input-name-live-feedback"
                          v-mask="mask"
                        ></b-form-input>
                      </b-form-group>
                    </b-col>
                    <b-col>
                      <b-form-group id="input-group-name">
                        <label for="input-name">Trạng thái:</label>
                        <b-form-select
                          v-model="status.selected"
                          :options="status.options"
                          aria-describedby="input-active-live-feedback"
                          size="sm"
                        ></b-form-select>
                      </b-form-group>
                    </b-col>
                  </b-col>
                  <b-col>
                    <b-form-group id="input-group-name">
                      <label for="input-name">Trạng thái kích hoạt:</label>
                      <b-form-select
                        v-model="activeStatus"
                        :options="statusActiveOptions"
                        value-field="value"
                        text-field="text"
                        aria-describedby="input-active-live-feedback"
                        size="sm"
                      ></b-form-select>
                      <template v-slot:first>
                        <b-form-select-option :value="null" disabled
                          >Chọn trạng thái kích hoạt</b-form-select-option
                        >
                      </template>
                    </b-form-group>

                    <b-form-group>
                      <label class="font-weight-bold">Ngày kích hoạt:</label>
                      <date-picker
                        placeholder="Chọn ngày kích hoạt"
                        class="form-control form-control-sm"
                        :config="dpConfigs.date"
                        v-model="activeDate"
                      ></date-picker>
                    </b-form-group>
                  </b-col>
                  <b-col></b-col>
                  <b-col></b-col>
                </b-row>
              </b-container>
            </b-form>
          </template>
          <template v-slot:foot>
            <b-container class="bv-example-row">
              <b-row>
                <b-col>
                  <b-col>
                    <b-button
                      style="fontweight: 600; width: 70px"
                      variant="primary"
                      size="sm"
                      type="submit"
                      @click="onSubmit"
                      >Lưu</b-button
                    >
                    <router-link to="/products" tag="button">
                      <b-button
                        style="margin-left: 10px; font-weight: 600; width: 70px"
                        variant="secondary"
                        size="sm"
                        >Hủy</b-button
                      >
                    </router-link>
                  </b-col>
                </b-col>
                <b-col></b-col>
                <b-col></b-col>
                <b-col></b-col>
              </b-row>
            </b-container>
          </template>
        </KTCodePreview>
      </div>
    </div>
  </div>
</template>
<style scoped>
.center-label label {
  margin-bottom: 0px;
}
</style>
<script>
import KTCodePreview from '@/view/content/CodePreview.vue';
import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module';

import ApiService from '@/core/services/api.service';
import {
  currencyMask,
  unMaskPrice,
  makeToastSuccess,
} from '@/utils/common';
import { IMEI_ACTIVE_STATUS_NAME } from '@/utils/enum-name';
import { IMEI_ACTIVE_STATUS } from '@/utils/enum';
import { convertToDateSlash, DP_CONFIG, DATE_FORMAT, formatDBDate } from '@/utils/date';
import { handleError } from '@/utils/common';

export default {
  data() {
    return {
      dpConfigs: {
        date: DP_CONFIG.date,
      },
      id: '',
      productEmeiStocks: [],
      listStore: [],
      selectedStore: '',
      imei: '',
      originalPrice: '',
      sellingPrice: '',
      status: {
        selected: null,
        options: [
          { value: null, text: 'Hãy chọn trạng thái' },
          { value: '1', text: 'Mới' },
          { value: '2', text: 'Đã bán' },
          { value: '3', text: 'Đang vận chuyển' },
          { value: '4', text: 'Lỗi' },
          { value: '5', text: 'Đã trả NCC' },
          { value: '6', text: 'Đang chuyển kho' },
          { value: '7', text: 'Đã trả bảo hành' },
          { value: '8', text: 'Đang bảo hành' },
        ],
      },
      statusActiveOptions: Object.values(IMEI_ACTIVE_STATUS).map((value) => ({
        value,
        text: IMEI_ACTIVE_STATUS_NAME[value],
      })),
      activeStatus: IMEI_ACTIVE_STATUS.NEW,
      activeDate: null,
      mask: currencyMask,
    };
  },
  components: {
    KTCodePreview,
  },
  mounted() {
    this.id = this.$route.query.id;
    this.getProductImeiById(this.id);
    this.fetchStore();
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: 'IMEI', route: '/imeis' },
      { title: 'Danh sách IMEI', route: '/imeis' },
      { title: 'Cập nhật chi tiết IMEI' },
    ]);
  },
  methods: {
    onSubmit: async function () {
      let params = {
        storeId: this.selectedStore,
        imeiNo: this.imei,
        originalPrice: unMaskPrice(this.originalPrice),
        sellingPrice: unMaskPrice(this.sellingPrice),
        status: this.status.selected,
        activeStatus: this.activeStatus,
        activeDate: formatDBDate(this.activeDate),
      };
      ApiService.post('productImeiStock' + '/' + this.id, { params }).then(
        (response) => {
          const {  message } = response.data;
            makeToastSuccess(message);
        },
      ).catch((error) => {
        handleError(error);
      });
    },
    fetchStore: async function () {
      ApiService.get(
        `stores?name=${this.search || ''}&limit=1000&page=${this.page || 1}`,
      ).then((response) => {
        response.data.data.list_store.map((item) => {
          let store = {
            id: item.id,
            name: item.name,
          };
          this.listStore.push(store);
        });
      });
    },
    getProductImeiById: async function (productImeiStockId) {
      ApiService.query(
        'productImeiStock/getProductImei' + '/' + productImeiStockId,
      ).then((response) => {
        ((this.selectedStore = response.data.data.storeId),
          (this.imei = response.data.data.imeiNo),
          (this.originalPrice = response.data.data.originalPrice),
          (this.sellingPrice = response.data.data.sellingPrice),
          (this.activeStatus = response.data.data.activeStatus),
          (this.activeDate = convertToDateSlash(
            response.data.data.activeDate,
            DATE_FORMAT,
          )),
          (this.status.selected = response.data.data.status));
      });
    },
  },
};
</script>

<style scoped>
.form-group label {
  font-weight: 600;
}
</style>
